import { Injectable } from '@angular/core';
// declare const pdfMake;
declare var pdfMake: any;

// Ref : https://github.com/BennyFranco/ng-pdf-make, https://github.com/bpampuch/pdfmake
// https://github.com/bpampuch/pdfmake/tree/master/dev-playground/public/samples
@Injectable()
export class PdfmakeService {
    // https://pdfmake.github.io/docs/document-definition-object/page/
    public pageSize = 'A4';
    public pageOrientation = 'portrait';

    private docDefinition: any;

    constructor() {

    }

    public initialize(pageSize = 'A4'): void {
        this.pageSize = pageSize;
        this.docDefinition = {
            pageSize: this.pageSize,
            pageOrientation: this.pageOrientation,
            content: [],
            styles: {}
        };

        pdfMake.tableLayouts = {
            exampleLayout: {
                hLineWidth: (i, node) => {
                    if (i === 0 || i === node.table.body.length) {
                        return 0;
                    }
                    return (i === node.table.headerRows) ? 2 : 1;
                },
                vLineWidth: (i) => 0,
                hLineColor: (i) => i === 1 ? 'grey' : '#aaa',
                paddingLeft: (i) => i === 0 ? 0 : 8,
                paddingRight: (i, node) => (i === node.table.widths.length - 1) ? 0 : 8
            }
        };
    }

    public open(): void {
        pdfMake.createPdf(this.docDefinition).open();
    }

    public print(): void {
        pdfMake.createPdf(this.docDefinition).print();
    }

    public download(name?: string): void {
        pdfMake.createPdf(this.docDefinition).download(name);
    }

    public configureStyles(styles): void {
        Object.assign(this.docDefinition.styles, styles);
    }

    public addHeader(text): void {
        this.docDefinition.content.push({ text, style: 'header' });
    }

    public addFooter(text): void {
        this.docDefinition.content.push({ text, style: 'footer' });
    }

    public addText(text: string, style?: string): void {
        if (style) {
            this.docDefinition.content.push({ text, style });
            return;
        }
        this.docDefinition.content.push(text);
    }

    // public addColumns(columnsText: string[]): void {
    //    const columns = [];
    //    for (const column of columnsText) {
    //        columns.push({ text: column });
    //    }

    //    this.docDefinition.content.push({ columns: columns });
    // }

    public addDynamic(content): void {
        this.docDefinition.content.push(content);
    }

    public addTable(header: Array<string>, body: Array<Array<any>>, widthValues: Array<any>): void {
        const content = {
            layout: 'tableLayouts', // optional
            table: {
                headerRows: 1,
                widths: widthValues,
                body: [
                    [ ...header ],
                    ...body
                  ]
            }
        };
        this.docDefinition.content.push(content);
    }

    public addImageData(data, width?: number, height?: number): void {
        let dict;
        if (width) {
            if (height) {
                dict = { image: data, width, height };
            } else {
                dict = { image: data, width };
            }
        } else {
            dict = { image: data };
        }

        this.docDefinition.content.push(dict);
    }

    public addImageUrl(url: string, width?: number, height?: number): void {
        let data;
        const image = new Image();

        image.setAttribute('crossOrigin', 'anonymous');
        image.src = url;

        image.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = image.naturalWidth;
            canvas.height = image.naturalHeight;

            canvas.getContext('2d').drawImage(image, 0, 0);

            data = canvas.toDataURL('image/png');
            let dict;
            if (width) {
                if (height) {
                    dict = { image: data, width, height };
                } else {
                    dict = { image: data, width };
                }
            } else {
                dict = { image: data };
            }

            this.docDefinition.content.push(dict);
        };
    }

    public addUnorderedlist(items: any[]): void {
        this.docDefinition.content.push({ ul: items });
    }

    public addOrderedList(items: any[], reversed?: boolean, start?: number): void {
        if (reversed) {
            this.docDefinition.content.push({ reversed, ol: items });
        } else if (reversed && start) {
            this.docDefinition.content.push({ reversed, start, ol: items });
        } else if (start) {
            this.docDefinition.content.push({ start, ol: items });
        } else {
            this.docDefinition.content.push({ ol: items });
        }
    }
}
